import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ServiceCard = ({ service }) => {
  return (
    <Link
      to={`/services/${service.slug}`}
      className="group relative flex flex-col h-full bg-white rounded-2xl overflow-hidden border border-black/5 hover:shadow-[0_22px_60px_rgba(0,0,0,0.12)] transition-all duration-300 hover:-translate-y-1.5"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display text-[20px] font-bold text-[#0e0e10] group-hover:text-[var(--tnf-orange)] transition-colors">
          {service.title}
        </h3>
        <p className="text-[14px] text-[#3b3b3b]/80 mt-2 leading-relaxed flex-1">
          {service.short}
        </p>
        <div className="flex items-center gap-2 mt-5 text-[14px] font-semibold text-[#0e0e10]">
          Learn more
          <span
            className="w-7 h-7 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-45"
            style={{ background: "var(--tnf-blue)" }}
          >
            <ArrowUpRight size={15} color="#fff" />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
